/* eslint-disable @typescript-eslint/lines-between-class-members */
import { PatchOpportunityParams } from '../interfaces/opportunity';

class PatchOpportunityParamsModel {
  fase?: string;
  placaVehiculo?: string;
  marcaVehiculo?: string;
  modeloVehiculo?: string;
  anioVehiculo?: string;
  zonaCirculacion?: string;
  nombres?: string;
  apellidoPaterno?: string;
  apellidoMaterno?: string;
  fechaNacimiento?: string;
  genero?: number;
  fechaCotizacion?: string;
  sumaAsegurada?: string | number;
  oferta?: string;
  codigoOferta?: string;
  precio?: string;
  codigoPromocion?: string;
  codigoChasis?: string;
  numeroMotor?: string;
  valorVehiculo?: string;
  fechaInicioVigencia?: string;
  pagoExitoso?: string;
  numeroPoliza?: string;
  direccion?: string;
  entidadBancaria?: string | null;
  conclusion?: string;
  sesionId?: string;
  clienteId?: string;
  identificadorCliente?: string;
  identificadorSolicitud?: string;
  identificadorVehiculo?: string;

  constructor(dataOpportunity: PatchOpportunityParams) {
    this.fase = dataOpportunity.chECFase_c;
    this.placaVehiculo = dataOpportunity.tAutoPlaca_c;
    this.modeloVehiculo = dataOpportunity.tAutoModelo_c;
    this.marcaVehiculo = dataOpportunity.tAutoMarca_c;
    this.anioVehiculo = dataOpportunity.nAutoYear_c;
    this.zonaCirculacion = dataOpportunity.tZona_c;
    this.nombres = dataOpportunity.tPerNombre_c;
    this.apellidoPaterno = dataOpportunity.tPerApellidoPaterno_c;
    this.apellidoMaterno = dataOpportunity.tPerApellidoPaterno_c;
    this.fechaNacimiento = dataOpportunity.dPerNacimiento_c;
    this.genero = dataOpportunity.chPerGenero_c;
    this.fechaCotizacion = dataOpportunity.dECCotizacion_c;
    this.sumaAsegurada = dataOpportunity.cECSumaAsegurada_c;
    this.oferta = dataOpportunity.tECOferta_c;
    this.codigoOferta = dataOpportunity.tCodigoDeOferta_c;
    this.precio = dataOpportunity.cECPrecio_c;
    this.codigoPromocion = dataOpportunity.tECPromocion_c;
    this.codigoChasis = dataOpportunity.tAutoChasis_c;
    this.numeroMotor = dataOpportunity.tAutoMotor_c;
    this.valorVehiculo = dataOpportunity.cAutoValor_c;
    this.fechaInicioVigencia = dataOpportunity.dOutVigenciaInicio_c;
    this.pagoExitoso = dataOpportunity.cbPagoExitoso_c;
    this.numeroPoliza = dataOpportunity.tECNumPoliza_c;
    this.direccion = dataOpportunity.tPerDireccion_c;
    this.entidadBancaria = dataOpportunity.tOutEntidad_c;
    this.conclusion = dataOpportunity.tEnrConclusion_c;
    this.sesionId = dataOpportunity.tAux1_c;
    this.clienteId = dataOpportunity.tAux2_c;
    this.identificadorCliente = dataOpportunity.identificadorCliente ?? '';
    this.identificadorSolicitud = dataOpportunity.identificadorSolicitud ?? '';
    this.identificadorVehiculo = dataOpportunity.identificadorVehiculo ?? '';
  }
}

export default PatchOpportunityParamsModel;
